import React from "react";
import classnames from "classnames";

import styles from "./SortableHeaderCell.module.css";
import {SortDirection} from "../../../api/generated";

export interface TableSort<F extends string = string> {
    sortBy?: F
    sortDirection?: SortDirection
}

export const nextTableSort = <F extends string>(current: TableSort<F>, sortBy: F): Required<TableSort<F>> => ({
    sortBy,
    sortDirection: current.sortBy === sortBy && current.sortDirection !== SortDirection.Desc
        ? SortDirection.Desc
        : SortDirection.Asc
})

interface SortableHeaderCellProps<F extends string> {
    title: string
    sortKey: F
    sort: TableSort<F>
    onSort: (sort: Required<TableSort<F>>) => void
    className?: string
}

export const SortableHeaderCell = <F extends string>({
                                                        title,
                                                        sortKey,
                                                        sort,
                                                        onSort,
                                                        className
                                                    }: SortableHeaderCellProps<F>) => {
    const isSorted = sort.sortBy === sortKey
    const isDescending = sort.sortDirection === SortDirection.Desc

    return <span className={className}>
        <button
            type="button"
            className={styles.button}
            onClick={() => onSort(nextTableSort(sort, sortKey))}
        >
            <span>{title}</span>
            {isSorted && <svg
                className={classnames(styles.arrow, isDescending && styles.arrowDown)}
                role="img"
                aria-label={isDescending ? "Sorted descending" : "Sorted ascending"}
                width="10" height="6" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd" clipRule="evenodd"
                    d="M13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976315 7.31658 -0.0976315 6.68342 0.292893 6.29289L6.29289 0.292893C6.68342 -0.0976315 7.31658 -0.0976315 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711Z"
                    fill="currentColor"/>
            </svg>}
        </button>
    </span>
}
